export default {
  All: '<<Tất cả>>',
  AllId: 'All',
  AllGuid: '00000000-0000-0000-0000-000000000000',
  AllInt: -1,
  AllText: 'Tất cả',

  Summary: '<<Tổng hợp>>',
  SummaryGuid: '99999999-9999-9999-9999-999999999999',
  SummaryId: 'Summary',
  SummaryInt: -2,
  SummaryText: 'Tổng hợp',

  None: '<<Không chọn>>',
  NoneText: 'Không chọn',
  NoneId: 'None',
  NoneInt: -3,

  Undetermined: '<<Không xác định>>',
  UndeterminedText: 'Không xác định',
  UndeterminedGuid: '11111111-1111-1111-1111-111111111111',
  UndeterminedInt: -4,
};

